<template>
  <div class="progress-bar__desktop" :class="route.name + greyLabelClass">
    <div class="progress-bar__desktop__el" :class="progressState.verification">
      <div class="progress-bar__desktop__background"></div>
      <div class="progress-bar__desktop__icon">
        <VerificationIcon />
      </div>
      <div class="progress-bar__desktop__copy">
        <h2 class="large-headline">{{ $t('ProgressBar.label.verify') }}</h2>
        <p>
          {{ $t('ProgressBar.text.verify') }}
        </p>
    </div>
    </div>
    <div class="progress-bar__desktop__el" :class="progressState.identity">
      <div class="progress-bar__desktop__background"></div>
      <div class="progress-bar__desktop__icon">
        <IdentityIcon />
      </div>
      <div class="progress-bar__desktop__copy">
        <h2 class="large-headline">{{ $t('ProgressBar.label.identify') }}</h2>
        <p>
          {{ $t('ProgressBar.text.identify') }}
        </p>
      </div>
    </div>
    <div class="progress-bar__desktop__el" :class="progressState.payment">
      <div class="progress-bar__desktop__background"></div>
      <div class="progress-bar__desktop__icon">
        <PaymentIcon />
      </div>
      <div class="progress-bar__desktop__copy">
        <h2 class="large-headline">
          {{ orderStore.isBuyMode ? $t('ProgressBar.label.payment') : $t('ProgressBar.label.deposit') }}
        </h2>
        <p v-if="orderStore.isBuyMode">
          {{ $t('ProgressBar.text.payment') }}
        </p>
        <p v-else>
          {{ $t('ProgressBar.text.deposit') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import {useOrderFormStore} from "@/stores/forms/orderFormStore";
import VerificationIcon from "@/components/icons/Verification.vue";
import PaymentIcon from "@/components/icons/Payment.vue";
import IdentityIcon from "@/components/icons/Identity.vue";

const store = useGlobalStore();
const orderStore = useOrderFormStore();
const route = useRoute();

const props = defineProps({
  progressState: {
    type: Object,
  },
});

const greyLabelClass = computed(() => store.getIsGreyLabel ? " grey-label" : "");
</script>
<style lang="scss">
.progress-bar__desktop {
  display: none;
  transition: opacity 250ms;

  &.order {
    opacity: 0.2;
  }

  @include breakpoint($min-m) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-auto-rows: 1fr;
    grid-row-gap: 2rem;
    padding: 2rem 0;
  }

  &__el {
    padding: 1.75rem 0;
    position: relative;
    display: flex;

    &.PENDING {
      opacity: 1;
    }

    &.COMPLETE {
      opacity: 0.25;
      transition: opacity 1000ms;
      transition-delay: 1000ms;
    }

    &.INCOMPLETE,
    &.order {
      opacity: 0.25;
    }
  }

  &__icon {
    padding: 0 2rem;
    svg {
      width: 3.2rem;
    }
  }

  &__copy {
    h2 {
      margin-bottom: 0.8rem;
    }
    p {
      opacity: 0.7;
      font-size: 1.2rem;
      line-height: 1.5;
    }
  }

  &__background {
    width: calc(100% + 3.4rem);
    height: 100%;
    background-color: var(--input-background);
    position: absolute;
    top: 0;
    z-index: -1;
    border-radius: $border-radius 0 0 $border-radius;

    .INCOMPLETE & {
      opacity: 0;
    }

    .COMPLETE & {
      opacity: 0;
      transition: opacity 0ms;
      transition-delay: 1000ms;
    }
  }
}

.progress-bar__desktop.grey-label {
  display: none;
}
</style>
